import { galleryTattoo, galleryPiercing, STUDIO } from "@/lib/studio";
import { Instagram, Quote, Star } from "lucide-react";

const realReviews = [
  {
    name: "Shalu Dubey",
    quote: "I can say without a doubt that this is the best tattoo studio I’ve ever visited. I’ve had two tattoos done here, and I want to give a massive thank you to Sanket and Manish for exceeding my expectations."
  },
  {
    name: "Riddhi Doshi",
    quote: "If you’re looking for the best tattoo experience, Vow Tattoo Studio is the place to go to. From the initial consultation to the final reveal, the team was truly professional and created the exact thing that I had come with in my mind. I loved their detailing work."
  },
  {
    name: "Yorrick Pinto",
    quote: "Got my first tattoo from Vow and it was really wow!! Very professional and fun people to be around. My tattoo artist Manish was really hands on since the day I went to enquiry. He helped me with the designs."
  },
  {
    name: "Ishika Sharma",
    quote: "If you’re looking for a top-tier tattoo experience, Vow Tattoo Studio is the place to go. From the initial consultation to the final reveal, the team was truly professional, taking my rough concepts and elevating them into a stunning piece."
  },
  {
    name: "Aditya Mohite",
    quote: "First of all Kudos to Manish who is the tattoo artist here, he consulted me well with ideas and the kind of artwork I was looking for. Patient and humble guy will always hear u out and suggest you better."
  },
  {
    name: "Shilpa Vishwakarma",
    quote: "Amazing experience for my first tattoo! I was a mix of excited and nervous, but the team was so patient and calm. They listened to exactly what I wanted and created a beautiful design that I love."
  },
  {
    name: "Ritu Vishwakarma",
    quote: "My experience with Vow studio was great I was worried to get tattooed but Manish helped and made me calm that everything will go smooth. The shop was incredibly clean and had a very welcoming, professional vibe."
  },
  {
    name: "Mamta Punnalla",
    quote: "If you are looking for creative, precise, and high-quality artwork, look no further. Manish was literally amazing. They took my rough idea and turned it into a masterpiece. The attention to detail is unmatched."
  },
  {
    name: "Khushi Bohra",
    quote: "I had an amazing experience with Sanket at Vow Tattoo Studio. He was very professional, patient, and brought my vision to life with incredible detail and clean lines. The studio was clean and welcoming."
  },
  {
    name: "Ayush Karmokar",
    quote: "Had the best experience at the Vow Tattoo Studios. I've gotten multiple tattoos and piercings from this place. The artist is sooo professional and considerate. It made the entire experience a 10/10."
  },
  {
    name: "Renya",
    quote: "I recently got my belly pierced and I’m so happy I did! I was a little nervous at first, but the whole experience was way better than I expected. The piercer was super professional and explained everything clearly."
  },
  {
    name: "Sayan Pal",
    quote: "I had an amazing experience at VOW TATTOO STUDIO! The studio was exceptionally clean, with every workstation meticulously sanitized before and after each client. The artists followed strict hygiene protocols."
  },
  {
    name: "Kunal Singh rajpurohit",
    quote: "Best best best i love it, also the vibe of the studio is so positive it feels like i am at my home so comfortable. Also the artists Manish and Sanket are so friendly they did not make me feel alone."
  },
  {
    name: "J.S Sen",
    quote: "This was my second visit to Vow Studio. I came back because I was completely satisfied with Manish's work on my first visit. He's professional and maintains excellent hygiene."
  },
  {
    name: "Vrajesh Shetty",
    quote: "I got my tattoo done here and recently also had my upper lobe piercing. The artist is extremely talented and dedicated to his work. He genuinely cares about his art and his customers."
  },
  {
    name: "Akshay Rai",
    quote: "One of the best artists in the game, Couldn’t appreciate Manish more for his talent and obviously vision for customized tattoos. I came with an idea and he literally did the design as I wanted, it’s beyond my expectations."
  },
  {
    name: "Rohan Pataria",
    quote: "Best tattoo artist! Peak detailing, perfect finishing, and highly skilled professional work. Totally satisfied with the result. Highly recommended 🔥"
  },
  {
    name: "Richa Lad",
    quote: "I got my tattoo done yesterday and am truly very impressed with their work. The tattoo is clear and has a perfect finish. The team is extremely kind, supportive and well-coordinated."
  },
  {
    name: "Yajit Gadkari",
    quote: "Amazing tattoo studio! Super clean, professional artists, and great attention to detail. The vibe is chill, and they really listen to what you want. Highly recommend for both first-timers and regulars!"
  },
  {
    name: "JITU MONDOL",
    quote: "Amazing vibe and super talented artist. He is the best colour tattoo artist. I just got my tattoo done, the best part is he customized all the designs and now I can say I carry something unique."
  }
];

export default function TestimonialsMarquee() {
  const loopQuotes = [...realReviews, ...realReviews];
  const galleryWork = [...galleryTattoo, ...galleryPiercing];
  const loopImages = [...galleryWork, ...galleryWork];

  return (
    <section className="relative py-8 md:py-12 overflow-hidden" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-5 md:px-8 mb-12 md:mb-16">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <div className="text-[10px] tracking-[0.34em] uppercase text-olive font-semibold mb-4">
              · Said about us
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-medium tracking-tighter text-cream leading-[1]">
              Voices from
              <br />
              <span className="italic font-light font-shadows text-3xl md:text-4xl lg:text-5xl">The Chair</span>
            </h2>
          </div>
          <a
            href={`https://instagram.com/${STUDIO.instagram.replace("@", "")}`}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 text-cream/80 hover:text-cream text-xs tracking-[0.22em] uppercase"
            data-testid="instagram-link"
          >
            <Instagram size={16} strokeWidth={1.6} />
            {STUDIO.instagram}
          </a>
        </div>
      </div>

      {/* Outline kinetic text */}
      <div className="marquee-wrapper overflow-hidden mb-10 border-y border-olive/20 py-4 md:py-6 bg-olive/10">
        <div className="marquee-track">
          {Array.from({ length: 2 }).map((_, n) => (
            <div key={n} className="flex items-center gap-12 pr-12">
              {["Fine Line", "Blackwork", "Neo-Traditional", "Piercings", "Custom Designs", "Cover-Ups"].map((w) => (
                <span key={w + n} className="font-display text-outline text-6xl md:text-8xl font-light tracking-tighter whitespace-nowrap">
                  {w} ·
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>

      {/* Testimonials marquee */}
      <div className="marquee-wrapper overflow-hidden mb-10">
        <div className="marquee-track gap-4">
          {loopQuotes.map((t, i) => (
            <figure
              key={i}
              className="shrink-0 w-[320px] md:w-[420px] border border-olive/30 bg-ink/70 p-7 flex flex-col justify-between"
              data-testid={`testimonial-${i % realReviews.length}`}
            >
              <div>
                <div className="flex items-center justify-between mb-4">
                  <Quote size={20} className="text-olive" strokeWidth={1.4} />
                  <div className="flex gap-1">
                    {[...Array(5)].map((_, idx) => (
                      <Star key={idx} size={14} className="text-olive fill-olive" />
                    ))}
                  </div>
                </div>
                <blockquote className="text-cream/85 text-sm md:text-base leading-relaxed font-body mb-5">
                  “{t.quote}”
                </blockquote>
              </div>
              <figcaption className="flex items-center justify-between text-[11px] tracking-[0.22em] uppercase mt-auto pt-4 border-t border-olive/10">
                <span className="text-cream">{t.name}</span>
                <span className="text-olive">Google Review</span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>

      {/* Instagram images marquee (reverse) */}
      <div className="marquee-wrapper overflow-hidden">
        <div className="marquee-track reverse gap-3">
          {loopImages.map((src, i) => (
            <a
              key={src + i}
              href={`https://instagram.com/${STUDIO.instagram.replace("@", "")}`}
              target="_blank"
              rel="noopener noreferrer"
              className="shrink-0 w-48 md:w-64 aspect-square border border-olive/20 overflow-hidden group relative"
              data-testid={`insta-tile-${i}`}
            >
              <img src={src} alt="Instagram feed" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" loading="lazy" />
              <div className="absolute inset-0 bg-ink/0 group-hover:bg-ink/40 transition-colors flex items-center justify-center">
                <Instagram size={24} className="text-cream opacity-0 group-hover:opacity-100 transition-opacity" strokeWidth={1.4} />
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
